<div class="modal-container" [ngClass]="{'hide-upload-modal': hide}">
  <div class="modal-content">
    <div class="upload-content">
      <div class="upload-content-header">
        <span>Anexos</span>
        <input
          #uploadBtnRef
          type="file"
          accept=".doc,.docx,.jpg,.jpeg,.pdf,.png,.ppt,.pptx,.xls,.xlsx"
          id="upload-btn-input"
          class="upload-btn"
          multiple
          [disabled]="attachedFilesSession.length > 8"
          (change)="verifyFiles('button')"
        >
        <label for="upload-btn-input" [ngClass]="{'disabled-input': attachedFilesSession.length > 8}">Carregar arquivos</label>
      </div>
      <div class="upload-content-display">
        <div class="display-grid">
          <div class="empty-grid" [ngClass]="{'hide-grid-btn': attachedFilesSession.length > 0}">
            <input
              #gridUploadBtnRef
              type="file"
              accept=".doc,.docx,.jpg,.jpeg,.pdf,.png,.ppt,.pptx,.xls,.xlsx"
              id="grid-upload-btn-input"
              class="grid-upload-btn"
              multiple
              (change)="verifyFiles('grid')"
            >
            <label for="grid-upload-btn-input">Clique para carregar os arquivos</label>
          </div>
          <div class="files-grid">
            <div class="files-grid-display" *ngFor="let file of attachedFilesSession; let j = index" [title]="file.name">
              <div class="filetype-document" *ngIf="file.icon">
                <img class="svg-icon" src="../../../../assets/svgs/{{ file.icon }}.svg" alt="icone_documento">
                <span>{{ file.fileExt }}</span>
              </div>
              <div class="filetype-document" *ngIf="!file.icon">
                <img class="thumb" [src]="file.content" alt="{{ file.name }}">
              </div>
              <div class="delete-btn" (click)="removeAttachedFile(j)">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.66634 1.2735L8.72634 0.333496L4.99967 4.06016L1.27301 0.333496L0.333008 1.2735L4.05967 5.00016L0.333008 8.72683L1.27301 9.66683L4.99967 5.94016L8.72634 9.66683L9.66634 8.72683L5.93967 5.00016L9.66634 1.2735Z" fill="black"/>
                </svg>
              </div>
            </div>
            <div class="files-grid-display-btn" title="adicionar arquivo" [ngClass]="{'hide-grid-btn': attachedFilesSession.length < 1 || attachedFilesSession.length > 8}">
              <input
                #gridUploadBtn2Ref
                type="file"
                accept=".doc,.docx,.jpg,.jpeg,.pdf,.png,.ppt,.pptx,.xls,.xlsx"
                id="grid-upload-btn2-input"
                class="grid-upload-btn2"
                multiple
                (change)="verifyFiles('grid2')"
              >
              <label for="grid-upload-btn2-input">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9678 1.06823H8.97376V8.97368H1.06831V10.9677H8.97376V18.8732H10.9678V10.9677H18.8733V8.97368H10.9678V1.06823Z" fill="#ACACAC"/>
                </svg>
              </label>
            </div>
          </div>
        </div>
        <p>Máximo de arquivos permitidos: 09</p>
        <p>Tamanho máximo dos arquivos: 2MB</p>
      </div>
      <div class="upload-content-footer">
        <lib-button-tertiary class="footer-btn" (click)="cancelUpload()">Cancelar</lib-button-tertiary>
        <lib-button-primary class="footer-btn" (click)="confirmUpload()">Concluir</lib-button-primary>
      </div>
    </div>
  </div>
</div>
